import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { User } from '../../models/user';
import { UserService } from '../../services/user/user.service';
import { environment } from '../../environments/environment';
import { ErrorService } from '../../services/error/error.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.css'],
})
export class AppShellComponent {
  readonly loading$: Observable<boolean>;
  readonly user$: Observable<User>;
  readonly error$: Observable<string>;
  readonly navigationLinks: ReadonlyArray<{ label: string; url: string }> = environment.navigationLinks;

  constructor(userService: UserService, router: Router, private errorService: ErrorService) {
    this.error$ = errorService.latesterror.asObservable();
    const onSignInPage$ = router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => isSignInUrl(event.urlAfterRedirects)),
      startWith(isSignInUrl(window.location.pathname))
    );

    // The sign-in page shows its own spinner, so skip the overlay there.
    this.loading$ = combineLatest([userService.loading$, onSignInPage$]).pipe(
      map(([loading, onSignInPage]) => loading && !onSignInPage)
    );
    this.user$ = userService.getUserUpdates();
  }

  getInitials(name?: string): string {
    const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
      return '';
    }

    return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  }

  dismissError(): void {
    this.errorService.insertError(null);
  }
}

function isSignInUrl(url: string): boolean {
  return url.toLowerCase().startsWith('/signin');
}
